import menu1 from "../../../../assets/images/menu/menu-1.png";
import menu2 from "../../../../assets/images/menu/menu-2.png";
import menu3 from "../../../../assets/images/menu/menu-3.png";
import menu4 from "../../../../assets/images/menu/menu-4.png";
import menu5 from "../../../../assets/images/menu/menu-5.png";
import menu6 from "../../../../assets/images/menu/menu-6.png";
import menu7 from "../../../../assets/images/menu/menu-7.png";
import menu8 from "../../../../assets/images/menu/menu-8.png";
import menu9 from "../../../../assets/images/menu/menu-9.png";
import menu10 from "../../../../assets/images/menu/menu-10.png";
import menu11 from "../../../../assets/images/menu/menu-11.png";
import menu12 from "../../../../assets/images/menu/menu-12.png";

export const menuList = [
  {
    icon: menu1,
    title: "Resume Medis",
    url: "/resume",
  },
  {
    icon: menu2,
    title: "Rujukan",
    url: "/rujukan",
  },
  {
    icon: menu3,
    title: "Vaksinasi",
    url: "/vaksinasi",
  },
  {
    icon: menu4,
    title: "Profil Fasilitas Kesehatan",
    url: "/faskes",
  },
  {
    icon: menu5,
    title: "Profil Tenaga Kesehatan",
    url: "/tenaga",
  },
  {
    icon: menu6,
    title: "Kirim Pesan",
    url: "/pesan",
  },
  {
    icon: menu7,
    title: "Riwayat Obat",
    url: "/obat/riwayat",
  },
  {
    icon: menu8,
    title: "Pengingat Obat",
    url: "/obat",
  },
  {
    icon: menu9,
    title: "Pemesanan Obat",
    url: "/obat/pemesanan",
  },
  {
    icon: menu10,
    title: "Tracking Data Kesehatan",
    url: "/monitoring",
  },
  {
    icon: menu11,
    title: "Skrining Kesehatan",
    url: "/screening",
  },
  {
    icon: menu12,
    title: "Kalkulator Kesehatan",
    url: "/monitoring/kalkulator",
  },
];
